import selectComponent from 'utilities/select-component'
import CustomInput from 'component/CustomInput'
import AjaxForm from 'component/AjaxForm'

const baseClass = 'form'

export default class RepForm extends AjaxForm {
    rep = window.rep

    constructor(element) {
        super(element)

        this.checkForRep()
    }

    handleSuccess = (data, textStatus, jqXHR) => {
        $.each(this.inputs, (name, field) => field.disable())

        this.$form.elements.submit
            .attr('disabled', 'disabled')

        this.rep = data
        this.$form
            .velocity({
                opacity: .8
            }, {
                duration: 1500,
                easing: 'easeOutCubic'
            })
            .velocity({
                opacity: 1
            }, {
                begin: () => {
                    this.checkSuccessMessage()
                },
                complete: () => {
                    this.$form.removeAttr('styles')
                    $.each(this.inputs, (name, field) => field.enable())

                    this.$form.elements.submit
                        .removeAttr('disabled')
                },
                duration: 750,
                easing: [1000, 20]
            })
    };

    checkForRep() {
        if(this.rep) {
            this.createSuccessMessage()
        }
    }

    checkSuccessMessage() {
        if (this.$form.elements.successMessage.html().length) {
            this.$form.elements.successMessage
            .velocity('transition.slideDownOut', {
                complete: () => {
                    this.createSuccessMessage()
                }
            })
            return
        }
        this.createSuccessMessage()
    }

    createSuccessMessage() {
        this.$form.elements.successMessage
            .html(
               this.repCard(this.rep)
            )
        this.$form.elements.successMessage
            .velocity('transition.slideUpIn', {
                complete: () => {
                    this.$form.elements.successMessage
                    .velocity('scroll',
                        {
                            offset: -200,
                            duration: 350,
                        }
                    )
                }
            })
    }

    repCard = rep => `
        <div class="regional-rep-search__result">
            <div class="representative-preview">
                <h3>${rep.company}</h3>
                <h4>${rep.repName}</h4>
                <p><a href="tel://${rep.phone}">${rep.phone}</a></p>
               ${rep.address1 &&
                    `<p>${rep.address1}</p>`
                }
               ${rep.address2 &&
                    `<p>${rep.address2}</p>`
                }
                ${(
                    rep.city
                    || rep.state
                    || rep.zip
                ) &&
                    `<p>
                        ${rep.city &&
                            `${rep.city},`
                        }
                        ${rep.state}
                        ${rep.zip}
                    </p>`
                }
            </div>
        </div>
    `;
    
}